// extracted by mini-css-extract-plugin
export var alert = "multi-alert-banner-module--alert--d99dc";
export var alertChild = "multi-alert-banner-module--alertChild--d8367";
export var banner = "multi-alert-banner-module--banner--b9f20";
export var marqueeTrack = "multi-alert-banner-module--marqueeTrack--dad53";
export var scrollBanner = "multi-alert-banner-module--scrollBanner--c5840";
export var scrollTextt = "multi-alert-banner-module--scroll-textt--923f9";
export var trackWrapper = "multi-alert-banner-module--trackWrapper--8d3a3";